import { Typography } from '@material-ui/core'

export default function CalendarForm() {
    return (
        <>
            <Typography style={{ textAlign: 'center', color: 'gray' }}>
                (View Only)
            </Typography>
        </>
    )
}
